import React, { useReducer, useRef, useState, useCallback, useEffect } from 'react';
import { useCreateDirectConversation } from '../chat/api';
import { ConsultationHeader } from '@/features/consults/shared/ConsultationHeader';
import ConversationPartial from '@/features/consults/chatpopup/partials/conversation';
import { reducer, initialState } from '@/features/consults/chat/reducer';
import { useProfile } from '@/contexts/profile';
import ConversationNoProductPartial from './partials/ConversationNoProduct';
import ListChatBubble, { ChatDetailType } from './partials/ListChat';
import { PagePath } from '@/layouts/shared';
import { useRouter } from 'next/router';
import { Message } from '../chat/const';
import { useDraggable } from '@/libs/hook';
export type IChat = {
  socket: any;
  isMobile: boolean;
  isAuth: boolean;
};

const ChatPopup = ({ socket, isMobile = false, isAuth }: IChat) => {
  const router = useRouter();
  const profile: any = useProfile();
  const userId = profile?.id || 0;
  const userName = profile?.fullname || '';
  const [chatDetail, setChatDetail] = useState<ChatDetailType>();
  const [state, dispatch] = useReducer(reducer, initialState);
  const [minimized, setMinimized] = useState(false);
  const [canStartNew, setCanStartNew] = useState(false);
  const [newMessage, setNewMessage] = useState<Message>();
  const [ids, setIds] = useState<number[]>([]);
  // Chỉ kéo nút mở chat; popup vẫn neo trong màn hình khi mở.
  const bubbleWrapRef = useRef<HTMLDivElement>(null);
  const [isSmallScreen, setIsSmallScreen] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 767px)');
    const update = () => setIsSmallScreen(mq.matches);
    update();
    mq.addEventListener?.('change', update);
    return () => mq.removeEventListener?.('change', update);
  }, []);
  useDraggable(bubbleWrapRef, { enabled: isAuth && (!chatDetail?.chatId || minimized), storageKey: 'fab_chat_pos', bottomGap: isSmallScreen ? 88 : 16, snapToEdge: true });

  const ZALO = process.env.ZALO || '';
  const FB = process.env.FB_PAGE_ID || '';
  const chatListRef = useRef<any>(null);
  useEffect(() => {
    const closeFloatingChat = () => {
      setChatDetail(undefined);
      setMinimized(false);
      setCanStartNew(false);
      chatListRef.current?.closeInbox();
    };
    router.events.on('routeChangeStart', closeFloatingChat);
    return () => router.events.off('routeChangeStart', closeFloatingChat);
  }, [router.events]);
  const seenMessage = useCallback((id: number) => {
    chatListRef.current?.seenMessage(id);
  }, []);
  useEffect(() => {
    const _ = localStorage.getItem('listChatBubble') || '{}';
    const listChatBubble = JSON.parse(_);
    if (listChatBubble && listChatBubble.userId == userId) {
      let _ = listChatBubble.ids.filter((v: any) => !!v);
      if (_.sort().join('') !== ids.sort().join('')) setIds(Array.from(new Set(_)));
    }
  }, [ids, userId]);
  const getCs = (fb: string, zalo: string) => {
    if (fb && zalo) return 'md:tw-mb-32';
    if (fb || zalo) return 'md:tw-mb-32';
    return 'md:tw-mb-6';
  };
  const closeChatDetail = () => {
    setMinimized(false);
    setCanStartNew(false);
    setChatDetail({
      chatId: null,
      productId: null,
    });
  };
  const { mutate: mutateCreateDirectConversation, isLoading } = useCreateDirectConversation({
    onSuccess: ({ data }) => {
      setMinimized(false);
      if (isMobile) {
        router.push({ pathname: PagePath.ConsultChatPage, query: { id: data.conversation.id } });
      } else {
        setChatDetail({
          chatId: data.conversation.id,
          productId: null,
        });
      }
    },
  });
  const setPChatDetail = (data: ChatDetailType) => {
    setMinimized(false);
    setCanStartNew(false);
    setChatDetail(data);
  };
  return (
    <div
      className={`consult-floating ${chatDetail?.chatId && !minimized ? 'consult-floating-active' : ''} ${minimized ? 'consult-floating-minimized' : ''} tw-fixed md:!tw-bottom-0 tw-flex tw-flex-col md:tw-flex-row tw-right-0 tw-px-3  md:tw-px-6 tw-gap-x-2 md:tw-gap-x-4 lg:tw-justify-end tw-items-end tw-z-50 tw-bottom-32`}
    >
      {chatDetail?.chatId && chatDetail?.productId && (
        <div className="consult-popup-frame tw-relative tw-order-2 md:tw-order-1">
          <ConsultationHeader conversationId={chatDetail.chatId} product={true} busy={isLoading} onNew={() => mutateCreateDirectConversation({})} onInbox={() => { closeChatDetail(); chatListRef.current?.openInbox(); }} onMinimize={() => setMinimized(true)} onClose={closeChatDetail} />
          <ConversationPartial
            conversationId={chatDetail.chatId}
            newMessage={newMessage}
            ownerId={userId}
            ownerName={userName}
            socket={socket}
            dispatch={dispatch}
            state={state}
            productId={chatDetail.productId}
            seenMessage={seenMessage}
          />
        </div>
      )}
      {chatDetail?.chatId && !chatDetail?.productId && (
        <div className="consult-popup-frame tw-relative tw-order-2 md:tw-order-1">
          <ConsultationHeader conversationId={chatDetail.chatId} product={false} canCreate={canStartNew} busy={isLoading} onNew={() => mutateCreateDirectConversation({})} onInbox={() => { closeChatDetail(); chatListRef.current?.openInbox(); }} onMinimize={() => setMinimized(true)} onClose={closeChatDetail} />
          <ConversationNoProductPartial
            onCanStartNew={setCanStartNew}
            conversationId={chatDetail.chatId}
            ownerId={userId}
            ownerName={userName}
            socket={socket}
            dispatch={dispatch}
            state={state}
            seenMessage={seenMessage}
            loading={isLoading}
            newMessage={newMessage}
            onBack={() => { closeChatDetail(); chatListRef.current?.openInbox(); }}
            createDirectConversation={() => mutateCreateDirectConversation({})}
          />
        </div>
      )}
      <div
        className={`tw-flex lg:tw-mb-24 ${
          chatDetail?.chatId ? `tw-flex-row  md:tw-mb-6` : `tw-flex-col`
        } md:tw-flex-col tw-order-1 md:tw-order-2 tw-w-full md:tw-w-auto tw-justify-end ${getCs(FB, ZALO)}`}
      >
        <ListChatBubble
          onResume={minimized ? () => setMinimized(false) : undefined}
          launcherRef={bubbleWrapRef}
          socket={socket}
          userId={userId}
          ref={chatListRef}
          setNewMessage={(data) => setNewMessage(data)}
          isChatDetail={!!chatDetail?.chatId && !minimized}
          setChatDetail={setPChatDetail}
          createNewDirectConversation={() => mutateCreateDirectConversation({})}
          isMobile={isMobile}
          listIds={ids}
          isAuth={isAuth}
        />
      </div>
    </div>
  );
};
export default ChatPopup;
